/**
 * @generated SignedSource<<acff3eac7f3539a58c7292d8971c8d77>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PopularArticles_getHelpTopics$data = {
  readonly topIssues: ReadonlyArray<{
    readonly label: string | null;
    readonly topicKey: string | null;
  } | null> | null;
  readonly " $fragmentType": "PopularArticles_getHelpTopics";
};
export type PopularArticles_getHelpTopics$key = {
  readonly " $data"?: PopularArticles_getHelpTopics$data;
  readonly " $fragmentSpreads": FragmentRefs<"PopularArticles_getHelpTopics">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PopularArticles_getHelpTopics",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GetHelpTopic",
      "kind": "LinkedField",
      "name": "topIssues",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "topicKey",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GetHelpTopics",
  "abstractKey": null
};

(node as any).hash = "e2c2a50d61c95a48e18b294528d97505";

export default node;
